module.exports = __webpack_public_path__ + "static/media/Follower_Green.07676e02.png";